"use client";

import { motion } from "framer-motion";
import { Cpu, Mic, Shield, Wifi } from "lucide-react";

const FEATURES = [
  { icon: Cpu, title: "Neural G3 Chip", body: "16-core silicon designed for on-device intelligence." },
  { icon: Mic, title: "Far-Field Array", body: "6 beam-forming mics hear you across the room." },
  { icon: Shield, title: "Private by Design", body: "End-to-end encryption. Audio never leaves the device." },
  { icon: Wifi, title: "Thread + Matter", body: "Works with 200,000+ smart devices, out of the box." },
];

export function Features() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
      },
    },
  };

  return (
    <section id="features" className="py-28 lg:py-32 bg-surface overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div 
          className="max-w-2xl"
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <p className="text-xs uppercase tracking-[0.25em] text-primary mb-5">
            Engineering
          </p>
          <h2 className="text-4xl lg:text-5xl font-semibold tracking-tight">
            Effortless on the outside.<br />Extraordinary inside.
          </h2>
        </motion.div>
        
        <motion.div 
          className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-border rounded-3xl overflow-hidden border border-border"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {FEATURES.map((f) => (
            <motion.div
              key={f.title}
              variants={itemVariants}
              className="bg-background p-10 hover:bg-card transition group"
            >
              <f.icon className="h-7 w-7 text-primary mb-8 group-hover:scale-110 transition-transform" strokeWidth={1.5} />
              <h3 className="text-lg font-semibold mb-2">{f.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{f.body}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
